/*
 * @Author: xinghanhu@clubfactory.com
 * PhotoPreview： 缩略图方式打开
 * @Date: 2019-05-30 13:34:08
 * @Last Modified by: xinghanhu@clubfactory.com
 * @Last Modified time: 2019-05-31 15:51:45
 */
import React from 'react';
import classnames from 'classnames';
import openPreview from './OpenDialog';
class PhotoPreview extends React.Component {
    constructor() {
        super(...arguments);
        this.showPhotoSwipe = (itemIndex, e) => {
            e.preventDefault();
            openPreview(Object.assign(Object.assign({}, this.props), { itemIndex }));
        };
    }
    render() {
        const { thumbnailClassName, items, thumbnailContent } = this.props;
        const thumbnailCls = classnames(['cfm_preview-thumbnails', thumbnailClassName]).trim();
        return (<div className={thumbnailCls}>
        {items.map((item, index) => (<div key={index} className="cfm_preview-thumbnail-item" onClick={(e) => this.showPhotoSwipe(index, e)}>
              {thumbnailContent(item)}
            </div>))}
      </div>);
    }
}
PhotoPreview.defaultProps = {
    options: {},
    thumbnailContent: (item) => (<img src={item.thumbnailSrc || item.src} width="100" height="100" alt=""/>),
    className: '',
};
PhotoPreview.open = openPreview;
export default PhotoPreview;



// WEBPACK FOOTER //
// ./components/photo-preview/PhotoPreview.tsx